<template>
    <div id="locale-changer">
          <b-button-group>
      <b-button class="flag_lang_button" @click="$i18n.locale='fr'"><img src="https://sportips.fr/live/img/Flags/FRA.jpg" alt=""></b-button>
      <b-button class="flag_lang_button" @click="$i18n.locale='en'"><img src="https://sportips.fr/live/img/Flags/GBR.jpg" alt=""></b-button>
    </b-button-group>
    <!-- <select v-model="$i18n.locale">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang"><img :src="getFlagUrl(lang)" alt=""></option>
    </select> -->
  </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { langs: ['fr', 'en'] }
  },
  methods:{
    getFlagUrl(){
      return "";
    }
  }
}
</script>

<style lang="scss" scoped>

</style>